import { AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChildren, ChangeDetectorRef, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../shared/commons/base-component/base.component';
import { Subscription } from 'rxjs/Subscription';
import { HelpersService } from '../../../../core/helpers/helpers.service';
import { Router } from '@angular/router';
import { ContentP } from '../../../../data/360-client-api';
import { BookmarkP, HomescreenVodsP, HomescreenVodsOpt } from '../../../../data/cms-vod-client-api';
import { AuthService } from '../../../../core/authentication/auth.service';
import { VodDataRestService } from '../../../../data/vod/vod-data-rest.service';
import { ContentExtended } from '../../../../data/vod/models/contentExtended';
import { DOCUMENT, DatePipe } from '@angular/common';
import { DataSharingService } from '../../../../core/data-sharing/data-sharing.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { isNullOrUndefined } from 'util';
import { ContentListResponse } from '../../../../data/cms-vod-client-api/model/contentListResponses';
import { setCarouselIndex } from '../../../../data/config';

// import * as $ from 'jquery';
declare var $: any;
declare var Glider: any;

@Component({
  selector: 'app-video-carousel',
  templateUrl: './video-carousel.component.html',
  styleUrls: ['./video-carousel.component.css'],

})
export class VideoCarouselComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() contentID: any;
  // @Input() allItemTitle: string;
  @Input() label: string;
  @Input() isRelatedContent;
  @Input() parentID;
  @Input() data: HomescreenVodsOpt;
  @Input() carouselIndex: number;
  @Input() contentType: string;
  @Input() isAccordionVisible: boolean;
  @Input() last: boolean;

  public contents: ContentListResponse[] = [];
  posterCatalogs: string[] = [];
  public contentSubs: Subscription;
  customerBookmarks: BookmarkP[];
  // watchedPercantages: any[] = [];
  episodes: ContentExtended[] = [];
  // $owl: any;
  glider: any;
  isAuthenticated: boolean;
  isContinueWatch: boolean = false;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  labelName: string;
  labelNameNoSpace: string;
  selectedContent: ContentListResponse = null;
  selectedLabel: string = null;
  summaryLong: string;
  bodyElement: HTMLElement;
  self = this;
  showCarousel: boolean = false;
  boolSubs: Subscription;

  @ViewChildren('carouselItems') carouselItems: QueryList<any>;
  private changeSubscription: Subscription;

  constructor(
    @Inject(DOCUMENT) private document: HTMLDocument,

    helpers: HelpersService,
    private dataSource: VodDataRestService,
    private router: Router,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private dataSharing: DataSharingService,
    private deviceService: DeviceDetectorService,
    private datePipe: DatePipe
  ) {
    super(helpers);
    this.isMobile = deviceService.isMobile();
    this.isTablet = deviceService.isTablet();
    this.isDesktop = deviceService.isDesktop();
    this.boolSubs = dataSharing.setBool$.subscribe(data => {
      if (data) {
        this.someBool = data;
      }
    })
  }

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  ngAfterViewInit() {
    this.bodyElement = document.getElementById('sportstv-body')

    super.ngAfterViewInit();

    if (this.isRelatedContent) {
      this.getReleatedContents();
    }
    else {
      this.setContents();
    }
    this.cdRef.detectChanges();

    // REF: https://stackoverflow.com/questions/37087864/execute-a-function-when-ngfor-finished-in-angular-2
  }

  getReleatedContents() {
    let id: any;
    if (this.contentType == "EPISODE") {
      id = this.parentID;
    }
    else {
      id = this.contentID;
    }

    this.dataSource.getRelatedContents(id).subscribe((data: ContentExtended[]) => {
      this.contents = data;
      this.carouselInit();

    });
  }



  setContents() {
    this.contents = <ContentListResponse[]>this.data.contentListResponses;
    this.label = this.data.labelName;

    if (this.contents.length > 40) {
      this.contents = this.contents.slice(0,40);
    }

    this.carouselInit();
  }


  carouselInit() {
    this.changeSubscription = this.carouselItems.changes.subscribe(t => {
      this.glider = new Glider(document.querySelector('#video-carousel-' + this.carouselIndex), {
        slidesToShow: 5,
        slidesToScroll: 1,
        draggable: true,
        rewind: true,
        duration: 1.2,
        dragVelocity: 1,
        responsive: [
          {
            // screens greater than >= 1024px
            breakpoint: 1350,
            settings: {
              slidesToShow: 4.2,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 767px
            breakpoint: 769,
            settings: {
              slidesToShow: 4.1,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 479px
            breakpoint: 479,
            settings: {
              slidesToShow: 3.3,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 479px
            breakpoint: 0,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 1,
            }
          },
        ],
        arrows: {
          prev: '#glider-prev-' + this.carouselIndex,
          next: '#glider-next-' + this.carouselIndex,
        }
      });
    });


    var thiz = this;
    document.querySelector('#video-carousel-' + this.carouselIndex).addEventListener('glider-loaded', function (event: any) {
      setTimeout(() => {
        // thiz.log(thiz.glider)
        var slides: HTMLElement[] = <Array<HTMLElement>>thiz.glider.slides;

        for (var i = 0; i <= 4; ++i) {
          // console.log("visible slide: ", slide.querySelectorAll('img'));

          if (!isNullOrUndefined(slides[i])) {
            var img: any = <any>slides[i].getElementsByTagName('img')[0];
            img.src = img.dataset.src;
          }
        }

        if (thiz.contents.length <= 4) {
          document.getElementById('glider-prev-' + thiz.carouselIndex).style.display = 'none';
          document.getElementById('glider-next-' + thiz.carouselIndex).style.display = 'none';
        }

        thiz.loadImages();
      }, 10);
    });

  }



  loadImages() {


    document.querySelector('#video-carousel-' + this.carouselIndex).addEventListener('glider-slide-visible', function (event: any) {

      var imgs_to_anticipate = 3;
      var glider = Glider(this);
      for (var i = 0; i <= imgs_to_anticipate; ++i) {
        var index = Math.min(event.detail.slide + i, glider.slides.length - 1),
          glider = glider;
        loadImages.call(glider.slides[index], function () {
          // glider.refresh(true);
        })
      }
      function loadImages(callback) {
        [].forEach.call(this.querySelectorAll('img'), function (img) {
          var _img = new Image, _src = img.getAttribute('data-src');

          _img.onload = function () {
            img.src = _src;
            img.classList.add('loaded');
            callback && callback(img);
          }
          if (img.src !== _src) _img.src = _src;
        });
      }

    });
  }

  getContentBookmark() {
    if (this.isAuthenticated) {
      this.dataSource.getCustomerBookmark().subscribe(data => {
        this.customerBookmarks = data;
        this.contents.forEach((content, i) => {
          this.customerBookmarks.forEach(bookmark => {
            if (content.id == bookmark.contentId) {
              if (bookmark.time == null || bookmark.duration == null) {
                // content.watchedPercantage = 0;
              }
              else {
                // this.watchedPercantages.push((bookmark.time / bookmark.duration) * 100)
                // content.watchedPercantage = (bookmark.time / bookmark.duration) * 100;
              }
            }
          });
          // if (this.watchedPercantages[i] == null) {
          //   this.watchedPercantages[i] = 0;
          // }
          // if (content.watchedPercantage == null) {
          //   content.watchedPercantage = 0;
          // }
        })
      });
    }
  }


  ngOnDestroy(): void {
    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
      this.changeSubscription = null;
    }

    if (this.boolSubs) {
      this.boolSubs.unsubscribe();
      this.boolSubs = null;
    }
  }

  // title_click() {
  //   setTimeout(() => {
  //     this.dataSharing.sendLabelName(this.data.labelName)
  //   }, 100);
  //   if (!this.isRelatedContent) {
  //     this.router.navigate(['/contentGrid/', this.data.labelId, this.data.labelName]);
  //   } else {
  //     // this.router.navigate(['/contentList', this.listID]);
  //     // WARN: no info to navigate to
  //   }
  //   return false;// WARN: Çok önemli olmaz ise 2 kere navigation olur
  // }

  someBool: boolean = true;
  routeDetail(temp) {
    console.log("clicked carousel index: ", this.carouselIndex);
    
    setCarouselIndex(this.carouselIndex)
    this.someBool = temp;
    //this.router.navigate(['/contentDetail', id, urlName]);

  }

  routeContentGrid() {    
    console.log("routeContentGrid", this.carouselIndex);
    
    setCarouselIndex(this.carouselIndex)
  }



  // labelNameNoSpace means CarouselIndex
  detail(content, labelNameNoSpace) {
    if (this.someBool) {
      if (content.type != 'SERIES') {
        setCarouselIndex(this.carouselIndex)
        if (this.isAccordionVisible) {
          if (this.isDesktop) {
            let object: any = {
              carouselID: labelNameNoSpace,
              contentID: content.id
            };

            this.dataSharing.sendCarouselID(object);
            let detailClass = document.getElementById(labelNameNoSpace)
            let selectedItem = document.getElementById(labelNameNoSpace + '' + content.id)
            if (this.selectedContent != null && (this.selectedContent.id != content.id)) {
              let oldItem = document.getElementById(this.carouselIndex + '' + this.selectedContent.id + '')
              oldItem.classList.remove('selected');
            }
            selectedItem.classList.add('selected');
            // let img = document.getElementById(this.selectedContent.id + '');
            // img.style.visibility = 'visible';
            this.selectedLabel = labelNameNoSpace;
            this.selectedContent = content;
            this.summaryLong = this.selectedContent.summaryLong;
            detailClass.classList.add('accordion-opened');
          }
          else {
            this.router.navigate(['/contentDetail', content.id, content.urlName]);
          }
        }
        else {
          if (!this.isDesktop) {
            this.router.navigate(['/contentDetail', content.id, content.urlName]);
          }
        }
      }
      else {
        if (!this.isDesktop) {
          this.router.navigate(['/contentDetail', content.id, content.urlName]);
        }
      }
    }
  }

  closeDetail(labelNameNoSpace) {
    let detailClass = document.getElementById(labelNameNoSpace)
    // let img = document.getElementById(this.selectedContent.id + '')
    let selectedItem = document.getElementById(labelNameNoSpace + '' + this.selectedContent.id)
    // img.style.visibility = 'hidden';
    selectedItem.classList.remove('selected');
    detailClass.classList.remove('accordion-opened');
  }


  likeContent() {
    this.dataSource.likeContent(this.selectedContent.id).subscribe(data => {
      if (data) {
        document.getElementById("like-button-1").style.backgroundColor = "green";
        document.getElementById("like-button-1").style.color = "white";
      }
    })
  }


  disLikeContent() {
    this.dataSource.disLikeContent(this.selectedContent.id).subscribe(data => {
      if (data) {
        document.getElementById("dislike-button-1").style.backgroundColor = "red";
        document.getElementById("dislike-button-1").style.color = "white";
      }
    })
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/widgets/video-carousel/video-carousel.component.ts